// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal[data-v-566fc39b]{background:rgba(0,0,0,.7)}.modal-head[data-v-566fc39b]{background:linear-gradient(135deg,#ffe543 .13%,#ffcd19 100.13%);-webkit-clip-path:circle(340px at 50% -102px);clip-path:circle(340px at 50% -102px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
